// Import our custom CSS
import '../scss/style.scss'

import 'jquery';


// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, EffectCreative, Thumbs, Autoplay, EffectFade  } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.min.css';

import '@fortawesome/fontawesome-pro/js/solid';
import '@fortawesome/fontawesome-pro/js/light';
import '@fortawesome/fontawesome-pro/js/fontawesome';
import '@fortawesome/fontawesome-pro/js/brands';

import GLightbox from 'glightbox';
import 'glightbox/dist/js/glightbox';
import 'glightbox/dist/css/glightbox.css'

/**
 * everything that happens after dom loads
 * */

// $('.navbar-toggler').click(function(){
//     $('.navigation-wrap').toggleClass('mobile-full');
// });
//
// $('.has-children').click(function () {
//     $(this).children('.megamenu-dropdown').toggleClass('open');
// });
//
// $('.ajax-navbar-mobile-toggle').click(function () {
//     $('.ajax-navbar-container').toggleClass('open');
// });
//
// let dropdowns = document.querySelectorAll('.dropdown-toggle')
// dropdowns.forEach((dd)=>{
//     dd.addEventListener('click', function (e) {
//         var el = this.nextElementSibling
//         el.style.display = el.style.display==='block'?'none':'block'
//     });
// });
//
// $('.navbar .dropdown').hover(function() {
//     $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();
//
// }, function() {
//     $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
//
// });
//
// $('.navbar .dropdown > a').click(function(){
//     location.href = this.href;
// });
document.addEventListener("DOMContentLoaded", function(){
  


    /////// Prevent closing from click inside dropdown
    document.querySelectorAll('.dropdown-menu').forEach(function(element){
        element.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    })


    // make it as accordion for smaller screens
    if (window.innerWidth < 992) {

        // close all inner dropdowns when parent is closed
        document.querySelectorAll('.navbar .dropdown').forEach(function(everydropdown){
            everydropdown.addEventListener('hidden.bs.dropdown', function () {
                // after dropdown is hidden, then find all submenus
                this.querySelectorAll('.submenu').forEach(function(everysubmenu){
                    // hide every submenu as well
                    everysubmenu.style.display = 'none';
                });
            })
        });

        document.querySelectorAll('.dropdown-menu a').forEach(function(element){
            element.addEventListener('click', function (e) {

                let nextEl = this.nextElementSibling;
                if(nextEl && nextEl.classList.contains('submenu')) {
                    // prevent opening link if link needs to open dropdown
                    e.preventDefault();
                    console.log(nextEl);
                    if(nextEl.style.display == 'block'){
                        nextEl.style.display = 'none';
                    } else {
                        nextEl.style.display = 'block';
                    }

                }
            });
        })
    }
    // end if innerWidth

    $('.bad').slideDown()
    $('.good').slideDown()
    setTimeout(function () {
        $('.bad').slideUp()
        $('.good').slideUp()
    }, 5000);
});
// DOMContentLoaded  end

var thumbsSwiper = new Swiper(".swiperThumbs", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    reverseDirection:true,
    freeMode: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    breakpoints: {
        240: {
          slidesPerView:2,
        },
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
        },
        992: {
            slidesPerView: 4,
          }
      }
  });
  var swiper2 = new Swiper(".SwiperHomepage", {
    modules: [Thumbs, Autoplay, EffectFade],
    loop: true,
    spaceBetween: 10,
    effect: "fade",
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
  var swiper3 = new Swiper(".ProjectSwiper", {
    modules: [Navigation, EffectCreative ],
    loop: true,
    spaceBetween: 50,
    effect: 'creative',
    observer: true, 
    observeParents: true,
    creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, 0, -400],
          duration:3000,
        },
        next: {
          translate: ["100%", 0, 0],
          duration:3000,
        },
      },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  });

  var swiper88 = new Swiper(".DienstDetailSwiper", {
    modules: [Navigation],
    slidesPerView:3,
    spaceBetween: 20,
    observer: true, 
    observeParents: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
          }
      }
  });

  const swiper92 = new Swiper(".swiper-proj", {
    modules: [Navigation],
    slidesPerView:1,
    observer: true, 
    observeParents: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  });

  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
  let smoother = ScrollSmoother.create({
  smooth: 1,
  });
  if ($(window).width() < 960) {
    $('.dropdown-toggle').attr('data-bs-toggle', 'dropdown');
    }
    else {
      $('.dropdown-toggle').removeAttr('data-bs-toggle');
    }
    $(document).ready(function(){
      $('#nav-icon2').click(function(){
        $(this).toggleClass('open');
      });
    });

    $(document).ready(function(){
    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true
    });
    var lightboxVideo = GLightbox({
      selector: '.glightbox3'
    });
});
    
